import { IResearchWorkItem } from "features/Research/types";
import { apiClient } from "lib/apiClient";

export const restoreResearchDemand = async (
  demandId: string,
  version: number
): Promise<IResearchWorkItem> => {
  const response = await apiClient.delete(
    `/research/demands/${demandId}/cancellation`,
    { data: { version } }
  );

  return response.data;
};
